<template>
    <div class="animated fadeIn">
        <div
            v-if="loading"
            class="kgr-postfix__fluid"
        >
            <kgr-loader />
        </div>
        <div
            v-if="showAlert"
            class="kgr-alert kgr-alert--info kgr-row kgr-postfix kgr-postfix--gutters kgr-postfix--top"
        >
            <div
                class="kgr-postfix__fluid"
            >
                <div v-show="!loading">
                    {{ message }}
                </div>
            </div>
            <div
                v-show="!loading"
                class="kgr-postfix__fixed"
            >
                <button
                    class="kgr-button kgr-button--accent"
                    @click="loadStatus()"
                >
                    {{ $t('Status überprüfen') }}
                </button>
            </div>
        </div>
        <div v-if="showContainer">
            <div class="kgr-inputGroup">
                <div class="kgr-grid kgr-grid--gutters kgr-grid--bigGutters">
                    <div class="kgr-grid__cell">
                        <kgr-form-row
                            :label="$t('Start')"
                            :error="error"
                            field-name="start"
                        >
                            <kgr-date-picker
                                v-model="start"
                            />
                        </kgr-form-row>
                    </div>
                    <div class="kgr-grid__cell">
                        <kgr-form-row
                            :label="$t('Ende')"
                            :error="error"
                            field-name="end"
                        >
                            <kgr-date-picker
                                v-model="end"
                            />
                        </kgr-form-row>
                    </div>
                </div>
            </div>
            <hr class="kgr-separator--light" />
            <div class="kgr-inputGroup">
                <kgr-accordion>
                    <kgr-accordion-item>
                        <template #header-left>
                            <h3 class="kgr-headline kgr-headline--h3 kgr-headline--text kgr-headline--firstInText">
                                {{ $t('Filter') }}
                            </h3>
                            <div class="kgr-text kgr-text--extraSmall">
                                {{ feeRadio && selected.length > 0 ? $t('Es wurden Beiträge selektiert') : $t('Alle Beiträge') }}
                            </div>
                        </template>
                        <div class="kgr-row">
                            <kgr-generic-radio
                                v-model="feeRadio"
                                :options="feeOptions"
                            />
                        </div>
                        <div
                            v-if="feeRadio"
                            class="kgr-row"
                        >
                            <kgr-checkbox
                                :label="$t('Alle auswählen')"
                                :checked="allChecked"
                                @change="toggleAll()"
                            />
                            <div
                                v-for="tupel in feesByDepartment"
                                :key="tupel.department ? tupel.department.id : 'none'"
                                class="kgr-row"
                            >
                                <h3 class="kgr-headline kgr-headline--h3">
                                    {{ $t('Abteilung') }}: {{ tupel.department ? tupel.department.name : "-" }}
                                </h3>
                                <table
                                    class="kgr-table kgr-table--block kgr-table--striped printable"
                                >
                                    <thead>
                                        <tr class="kgr-table__row">
                                            <th class="kgr-table__cell kgr-table__cell--headline kgr-table__cell--actions kgr-hidden-print">
                                                <kgr-checkbox
                                                    :checked="isAllCheckedInDepartment(tupel)"
                                                    :inactive="isIndeterminateInDepartment(tupel)"
                                                    @change="toggleAllInDepartment(tupel)"
                                                />
                                            </th>
                                            <th class="kgr-table__cell kgr-table__cell--headline">
                                                {{ $t('Name') }}
                                            </th>
                                            <th class="kgr-table__cell kgr-table__cell--headline">
                                                {{ $t('Kategorie') }}
                                            </th>
                                            <th class="kgr-table__cell kgr-table__cell--headline">
                                                {{ $t('Preis') }}
                                            </th>
                                            <th class="kgr-table__cell kgr-table__cell--headline">
                                                {{ $t('zu zahlen') }}
                                            </th>
                                            <th class="kgr-table__cell kgr-table__cell--headline">
                                                {{ $t('Zahlungsintervall') }}
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr
                                            v-for="fee in tupel.fees"
                                            :key="fee.id"
                                            class="kgr-table__row"
                                        >
                                            <td class="kgr-table__cell">
                                                <kgr-checkbox
                                                    :checked="isSelected(fee.id)"
                                                    @change="toggleFee(fee.id)"
                                                />
                                            </td>
                                            <td class="kgr-table__cell">
                                                {{ fee.name }}
                                            </td>
                                            <td class="kgr-table__cell">
                                                {{ fee.category }}
                                            </td>
                                            <td class="kgr-table__cell">
                                                {{ fee.price }}
                                            </td>
                                            <td class="kgr-table__cell">
                                                {{ fee.paymentApproach }}
                                            </td>
                                            <td class="kgr-table__cell">
                                                {{ fee.paymentInterval }}
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </kgr-accordion-item>
                </kgr-accordion>
            </div>
            <hr class="kgr-separator--light" />
            <div class="kgr-row">
                <div class="kgr-text--rightAligned">
                    <button
                        class="kgr-button kgr-button--accent"
                        @click="openConfirmModal()"
                        :disabled="pending"
                    >
                        {{ $t('Rechnungslauf starten') }}
                    </button>
                </div>
                <div v-show="pending">
                    {{ $t('SEPA-Lastschriften-Check wird ausgeführt ...') }}
                </div>
                <div v-show="invalidSepaDebits.length > 0 && !pending">
                    <div class="mb1">
                        {{ $t('Es wurden ungültige SEPA-Lastschriften gefunden:') }}
                    </div>
                    <ul
                        v-for="(invalidSepaDebit, index) in invalidSepaDebits"
                        :key="index"
                        class="kgr-list kgr-list--bulleted"
                    >
                        <li>
                            <a class="kgr-link" :href="invalidSepaDebit.link ">{{ invalidSepaDebit.member }}</a>:
                            {{ invalidSepaDebit.iban }} {{ invalidSepaDebit.bic ? `(${invalidSepaDebit.bic})` : '' }}
                            <span v-if="invalidSepaDebit.correctBic">
                                - {{ $t('korrekter BIC:') }} {{ invalidSepaDebit.correctBic }}
                                <SphIcon
                                    :icon="iconConfig(invalidSepaDebit.bankAccountId).icon"
                                    size="md"
                                    :class="iconConfig(invalidSepaDebit.bankAccountId).class"
                                    :title="iconConfig(invalidSepaDebit.bankAccountId).title"
                                    style="vertical-align: middle; position: relative; top: -2px;"
                                    :style="iconConfig(invalidSepaDebit.bankAccountId).style"
                                    @click="updateBic(invalidSepaDebit)"
                                />
                            </span>
                            <span v-else>- {{ $t('Bitte IBAN und BIC prüfen') }}</span>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
        <kgr-invoicing-confirm-modal
            :show-dialog="showConfirmModal"
            @confirm="onConfirm"
            @cancel="onCancel"
        />
    </div>
</template>

<script>
import { ArrowRightLeft, Check, X } from 'lucide';
import { endOfMonth, format, parse, startOfMonth } from '@legacy/js/date/date-fns.js';
import Accordion from '../../../components/common/accordion/Accordion.vue';
import AccordionItem from '../../../components/common/accordion/AccordionItem.vue';
import Checkbox from '../../../components/common/form/checkbox/Checkbox.vue';
import ClubFeeRepository from '../../../js/repository/ClubFeeRepository.js';
import DatePicker from '../../../components/common/form/picker/DatePicker.vue';
import Error from '../../../js/model/Error.js';
import FormRow from '../../../components/common/form/FormRow.vue';
import GenericRadio from '../../../components/common/form/radio/GenericRadio.vue';
import Helper from '../../../js/accounting/Helper.js';
import InvoicingConfirmModal from '@legacy/components/club/accounting/InvoicingConfirmModal.vue';
import Loading from '../../../components/common/Loading.vue';
import { SphIcon } from '@/components/base/icon/index.ts';
import axios from 'axios';

export default {
    components: {
        'kgr-accordion': Accordion,
        'kgr-accordion-item': AccordionItem,
        'kgr-checkbox': Checkbox,
        'kgr-date-picker': DatePicker,
        'kgr-form-row': FormRow,
        'kgr-generic-radio': GenericRadio,
        'kgr-invoicing-confirm-modal': InvoicingConfirmModal,
        'kgr-loader': Loading,
        SphIcon,
    },
    props: {
        clubId: {
            type: Number,
            required: true,
        },
    },
    data() {
        return {
            error: new Error(),
            feeOptions: {
                'Alle Beiträge': false,
                'Beiträge auswählen': true,
            },
            loading: false,
            pending: false,
            feeRadio: false,
            club: null,
            running: false,
            disabled: false,
            helper: new Helper(),
            selected: [],
            feesByDepartment: [],
            clubFees: [],
            start: format(startOfMonth(new Date()), 'dd.MM.yyyy'),
            end: format(endOfMonth(new Date()), 'dd.MM.yyyy'),
            invalidSepaDebits: [],
            showConfirmModal: false,
            ArrowRightLeft,
            Check,
            X,
            updatedBicIds: [],
            failedBicIds: [],
        };
    },
    computed: {
        allChecked() {
            const allIds = this.feesByDepartment.flatMap((dep) => dep.fees.map((f) => f.id));
            return allIds.length > 0 && allIds.every((id) => this.selected.includes(id));
        },
        message() {
            return this.disabled
                ? this.$t('Der Rechnungslauf ist für kurze Zeit deaktiviert. Bitte versuche es in wenigen Minuten noch einmal.')
                : this.$t('Es wird bereits ein Rechnungslauf durchgeführt.');
        },
        showAlert() {
            return !this.loading && (this.running || this.disabled);
        },
        showContainer() {
            return !this.loading && !this.running && !this.disabled;
        },
        params() {
            const params = {};
            if (this.feeRadio) {
                params.fees = [];
                this.selected.forEach((feeId) => {
                    params.fees = params.fees.concat(feeId);
                });
            }
            return params;
        },
        accountingPeriod() {
            const start = parse(this.start, 'dd.MM.yyyy', new Date());
            const formattedStart = format(start, 'yyyy-MM-dd');
            const end = parse(this.end, 'dd.MM.yyyy', new Date());
            const formattedEnd = format(end, 'yyyy-MM-dd');
            return `${formattedStart}:${formattedEnd}`;
        },
    },
    created() {
        this.loadStatus();
        this.loadFees();
    },
    methods: {
        toggleAll() {
            const allIds = this.feesByDepartment.flatMap((dep) => dep.fees.map((f) => f.id));
            if (this.allChecked) {
                this.selected = [];
            } else {
                this.selected = [...allIds];
            }
        },
        isSelected(feeId) {
            return this.selected.includes(feeId);
        },
        toggleFee(feeId) {
            const idx = this.selected.indexOf(feeId);
            if (idx === -1) {
                this.selected.push(feeId);
            } else {
                this.selected.splice(idx, 1);
            }
        },
        toggleAllInDepartment(tupel) {
            const feeIds = tupel.fees.map((fee) => fee.id);
            const allSelected = feeIds.every((id) => this.selected.includes(id));

            if (allSelected) {
                this.selected = this.selected.filter((id) => !feeIds.includes(id));
            } else {
                feeIds.forEach((id) => {
                    if (!this.selected.includes(id)) {
                        this.selected.push(id);
                    }
                });
            }
        },
        isAllCheckedInDepartment(tupel) {
            const feeIds = tupel.fees.map((fee) => fee.id);
            return feeIds.length > 0 && feeIds.every((id) => this.selected.includes(id));
        },
        isIndeterminateInDepartment(tupel) {
            const feeIds = tupel.fees.map((fee) => fee.id);
            const selectedInDept = feeIds.filter((id) => this.selected.includes(id)).length;
            return selectedInDept > 0 && selectedInDept < feeIds.length;
        },
        getPrice(fee) {
            return this.helper.getPricePerTime(fee.priceHistory.getCurrentPricePerTime());
        },
        openConfirmModal() {
            this.showConfirmModal = true;
        },
        onCancel() {
            this.showConfirmModal = false;
        },
        onConfirm(payload) {
            this.showConfirmModal = false;
            if (payload.doPrecheck) {
                this.precheckInvoicing();
            } else {
                this.createInvoicing();
            }
        },
        precheckInvoicing() {
            this.updatedBicIds = [];
            this.failedBicIds = [];
            this.pending = true;
            axios
                .post(`/club/clubs/${this.clubId}/invoice-asset-prototypes/precheck?accountingPeriod=${this.accountingPeriod}`, this.params)
                .then((response) => {
                    this.invalidSepaDebits = response.data.data;
                    if (this.invalidSepaDebits.length === 0) {
                        this.createInvoicing();
                    }
                })
                .catch(() => this.$notify.error('error.loadingData'))
                .finally(() => this.pending = false);
        },
        createInvoicing() {
            this.loading = true;
            axios
                .post(`/club/clubs/${this.clubId}/invoice-asset-prototypes?accountingPeriod=${this.accountingPeriod}`, this.params)
                .then(() => this.loadStatus());
        },
        loadStatus() {
            this.loading = true;
            axios
                .get(`/club/clubs/${this.clubId}/invoicing`)
                .then((response) => {
                    this.running = response.data.data.isRunning;
                    this.disabled = response.data.data.isDisabled;
                    this.loading = false;
                });
        },
        loadFees() {
            this.loading = true;
            ClubFeeRepository
                .findByClub(this.clubId)
                .then((fees) => {
                    const departmentIds = fees.map((fee) => fee.department?.id);
                    const uniqueDepartmentIds = [...new Set(departmentIds)];
                    this.feesByDepartment = uniqueDepartmentIds.map((departmentId) => {
                        const department = fees.find((fee) => fee.department?.id === departmentId)?.department;
                        return {
                            department,
                            fees: fees.filter((fee) => fee.department?.id === departmentId).map((fee) => {
                                return {
                                    id: fee.id,
                                    name: fee.name,
                                    category: fee.category.name,
                                    price: this.getPrice(fee),
                                    paymentApproach: this.helper.translatePaymentApproach(fee.paymentApproach),
                                    paymentInterval: this.helper.getPaymentInterval(fee),
                                };
                            }),
                        };
                    }).sort((a, b) => {
                        if (!a.department) {
                            return -1;
                        }
                        if (!b.department) {
                            return 1;
                        }
                        return a.department?.name.localeCompare(b.department?.name);
                    });
                    this.loading = false;
                });
        },
        updateBic(invalidBankAccount) {
            if (this.updatedBicIds.includes(invalidBankAccount.bankAccountId)) {
                return;
            }
            const data = {
                owner: invalidBankAccount.owner,
                iban: invalidBankAccount.iban,
                bic: invalidBankAccount.correctBic,
            };
            axios
                .put(`/club/member-bank-accounts/${invalidBankAccount.bankAccountId}`, data)
                .then(() => this.updatedBicIds.push(invalidBankAccount.bankAccountId))
                .catch(() => this.failedBicIds.push(invalidBankAccount.bankAccountId));
        },
        iconConfig(bankAccountId) {
            if (this.updatedBicIds.includes(bankAccountId)) {
                return {
                    icon: Check,
                    title: this.$t('BIC wurde übernommen'),
                    class: 'text-success',
                };
            }
            if (this.failedBicIds.includes(bankAccountId)) {
                return {
                    icon: X,
                    title: this.$t('BIC konnte nicht übernommen werden'),
                    class: 'text-error',
                };
            }
            return {
                icon: ArrowRightLeft,
                title: this.$t('BIC übernehmen'),
                style: 'cursor: pointer',
            };
        },
    },
};
</script>
